import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import FullServiceRemovalSolutions from "./sections/FullServiceRemovalSolutions";
import OurExpertSolutions from "./sections/OurExpertSolutions";
import About from "./sections/About";
import ContactFooterInformation from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <FullServiceRemovalSolutions />
      <OurExpertSolutions />
      <About />
      <ContactFooterInformation />
    </div>;
}